
    import { Component, Vue, Prop } from 'vue-property-decorator';
    
    import { stepInfoType } from "@/types/Application";
    import StepBase from "../StepBase.vue";
    import ReviewYourAnswers from "./ReviewYourAnswers.vue"

    @Component({
        components:{
            StepBase,
            ReviewYourAnswers,
        }
    })

    export default class review extends Vue {
        
        @Prop({required: true})
        step!: stepInfoType;
        
    }
